<div class="rd-widget widget-2xCol pictureWidget rd-widget-no-height-restriction" [style.height.px]="widgetHeight" *ngIf="widgetData">
  <table class="widget-flex" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-flex">
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngIf="editMode">
        <th scope="col" colspan="16" class="widget-title-left">{{'picture.labelPropertyPicture' | rdTranslate}}</th>
        <td colspan="16" class="space">&nbsp;</td>
      </tr>
      <tr *ngIf="editMode">
        <td colspan="16" class="space">&nbsp;</td>
      </tr>

      <tr [hidden]="!editMode">
        <td colspan="16" class="widgetImageTypePlaceholder">
          <p>
            <span>
              {{widgetConfig.widgetSettings.currentLayout}}
            </span>
          </p>
        </td>
      </tr>

      <tr [hidden]="editMode">
        <td class="widgetImagePlaceholder" [ngClass]="layoutCssClass"
            colspan="16"
            [ngStyle]="{ 'background': 'url(' + widgetData.pictureDataUrl + ')'}">
        </td>
      </tr>

      <tr>
        <td colspan="16" class="widgetImageDescriptionPlaceholder widget-align-center widget-nowrap">
          {{widgetData.pictureDescription}}
        </td>
      </tr>
    </tbody>
    
  </table>
</div>
